import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import Ctapage from "../../Components/internal-pages/Cta_Section";
import Whychooseus from "../../Components/internal-pages/WhyChooseus";
import ClinetsLogoSlider from "../../Components/home/ClientsLogoSlider";
import CustomerTestimonials from "../../Components/home/CustomerTestimonials";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";


const CorporateGiftingLP = () => {

    const contactFormRef = useRef(null);    

    const CTAContent = [
        {
            pageName: "Premium Corporate Gifting Solutions",
            paragraphitalic: "Bulk orders, custom branding, & fast delivery.",
            paragraphText:
                "At eYantra, we specialize in corporate gifting solutions tailored to your brand. Whether it’s employee welcome kits, client gifts, or event giveaways, we provide high quality products with custom branding and on time delivery. ",
            ContactFormName: "Landing page-Corporate Gifting",
        },
    ];
    return (
        <>
            <Helmet>
                <title>
                    Corporate Gifting Solutions | Premium Business Gifts
                </title>
                <meta name="description" content="Explore premium corporate gifting solutions for clients & employees. Discover customized, bulk, and unique business gift ideas for every occasion." />
            </Helmet>
            <div className="p-0 m-2">
                <Ctapage data={CTAContent} contactRef={contactFormRef} />

            </div>
            <div className="my-5">
                <ClinetsLogoSlider />
            </div>
            <Whychooseus />
            <CustomerTestimonials />

            <div>
                <p className="text-center fs-24 w-75 d-block m-auto py-5">
                    At eYantra, we specialize in corporate gifting solutions tailored to your brand. Whether it's employee welcome kits, client gifts, or event giveaways, we provide high quality products with custom branding and on time delivery.
                    <Link to="https://shop.eyantra.com/?utm_source=Google&utm_medium=Search" target="noblank" className="text-decoration-none">
                        <Button id="btnCTA" className="m-auto d-block px-5 rounded-5 my-3">
                            Shop Now
                        </Button>
                    </Link>
                </p>


            </div>

        </>
    )
}

export default CorporateGiftingLP;